import { interpolate } from './interpolate';

/**
 * Darkens a given color by interpolating it towards black by a specified amount.
 *
 * @param color - The base color to darken, as a string (e.g., hex or CSS color).
 * @param amount - The interpolation amount between 0 and 1, where 0 returns the original color and 1 returns black.
 * @returns The resulting darkened color as a string.
 */
export const interpolateDarken = (color: string, amount: number): string => {
  return interpolate(color, '#000000', amount);
};
